var _path, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_42_1",
    "data-name": "Component 42 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.872,
    height: 50.403,
    viewBox: "0 0 39.872 50.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M364.909,480.324c0-1.756-.009-3.378,0-5a12.26,12.26,0,0,1,9.714-12.091,12.063,12.063,0,0,1,14.493,10.6,7.285,7.285,0,0,1,.034,1.612A1.469,1.469,0,0,1,387.6,476.8c-.622.027-1.247.025-1.868.006a1.53,1.53,0,0,1-1.695-1.648,7.082,7.082,0,0,0-2.1-4.954,6.825,6.825,0,0,0-11.657,4.042,54.947,54.947,0,0,0-.171,5.513c-.019.591.337.564.737.563q4.388-.006,8.776,0c3.656,0,7.313-.006,10.969,0a3.5,3.5,0,0,1,3.839,3.822q.017,5.688,0,11.376c-.025,5.412-3.694,9.056-9.094,9.058q-8.41,0-16.82,0a8.523,8.523,0,0,1-8.584-6.844,11.226,11.226,0,0,1-.214-2.339c-.021-3.684.042-7.368-.029-11.051-.043-2.241,1.337-4.234,4.068-4.026C364.1,480.346,364.448,480.324,364.909,480.324Zm8.718,10.406-.2.1a6.8,6.8,0,0,0,1.062,2.087,2.458,2.458,0,0,1,.827,2.261,3.835,3.835,0,0,0,0,.648,1.824,1.824,0,0,0,1.737,1.794,1.806,1.806,0,0,0,1.754-1.775,10.817,10.817,0,0,0,0-1.46,1.155,1.155,0,0,1,.5-1.085,3.373,3.373,0,0,0,.828-4.187,3.485,3.485,0,0,0-3.984-1.745A3.427,3.427,0,0,0,373.627,490.73Z",
    transform: "translate(-357.127 -462.946)",
    fill: "#de5454"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 2.848,
    cy: 2.848,
    r: 2.848,
    transform: "translate(22.784 44.707)",
    fill: "#de5454"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 2.848,
    cy: 2.848,
    r: 2.848,
    transform: "translate(34.176 44.707)",
    fill: "#de5454"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 2.848,
    cy: 2.848,
    r: 2.848,
    transform: "translate(0 44.707)",
    fill: "#de5454"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 2.848,
    cy: 2.848,
    r: 2.848,
    transform: "translate(11.392 44.707)",
    fill: "#de5454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/lock.icon.b591d4a03a5848ef792d7030c4fecced.svg";
export { ForwardRef as ReactComponent };